import BaseHttpService from "JS/services/BaseHttpService";
import { IBaseHttpService } from "JS/types/Http";
import { IDropOffDatesResource, ITimeSlotsResource } from "../types/appointment";

export interface IAutomotiveSchedulerAppointmentService {
	getAvailableTimeSlots(): Promise<ITimeSlotsResource>;
	getAvailableDropoffDates(): Promise<IDropOffDatesResource>;
}

export class AutomotiveSchedulerAppointmentService implements IAutomotiveSchedulerAppointmentService {
	constructor(private _httpService: IBaseHttpService = new BaseHttpService()) {}

	getAvailableTimeSlots(): Promise<ITimeSlotsResource> {
		return this._httpService.get("/automotive-scheduler/appointment/available-time-slots");
	}

	getAvailableDropoffDates(): Promise<IDropOffDatesResource> {
		return this._httpService.get("/automotive-scheduler/appointment/available-dropoff-dates");
	}
}